import { render, staticRenderFns } from "./FromRegistry.vue?vue&type=template&id=a6bc9626&scoped=true"
import script from "./FromRegistry.vue?vue&type=script&lang=js"
export * from "./FromRegistry.vue?vue&type=script&lang=js"
import style0 from "./FromRegistry.vue?vue&type=style&index=0&id=a6bc9626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bc9626",
  null
  
)

export default component.exports